import React from 'react';

export const disallowComma = (keyEvent: React.KeyboardEvent) => {
  if (keyEvent.code === 'Comma') {
    keyEvent.preventDefault();
  }
};
